if($('.type-detail').length){
    if($('.flags-default').find('.flag-custom2').length){
        $('.p-image').append($('.p-detail .flag-custom2'))
    }
   // $('.p-info-wrapper .add-to-cart').append('<span class="btn_toggle"></span>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="availRow"></div><div class="kosik"></div>')
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'));
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: <strong>'+$('.delivery-time').html()+'</strong></div>')
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    $('.availRow').append($('.availability-value'));
    if($('.description-inner .extended-description').length){
        $('#p-detail-tabs li').first().after('<li class="shp-tab" data-testid="tabProductsParameters" data-width=""><a href="#productsParameters" class="shp-tab-link" role="tab" data-toggle="tab">Parametry</a></li>')
        $('#tab-content').append('<div id="productsParameters" class="tab-pane fade" role="tabpanel">'+$('.description-inner .extended-description').html()+'</div>')
    }
    if($('.shp-tabs-row a[href="#relatedFiles"]').length){
        $('.shp-tabs-row a[href="#relatedFiles"]').text('Ke stažení')
    }   
   
}